module.exports = __webpack_public_path__ + "static/AvenirNext-BoldItalic-7077eb15091c2fb349f4aa25d458c98e.woff";